import type { SxProps, Theme } from "@mui/material";
import { Box } from "@mui/material";
import React, { useMemo } from "react";
import { stringifyValue } from "@entrilia/shared/utilities/stringHelper";

export interface TabPanelProps<T> {
  children?: React.ReactNode;
  selectedTab: T;
  value: T;
  sx?: SxProps<Theme>;
}

export function PersistedTabPanel<T>({ children, value, selectedTab, sx, ...other }: TabPanelProps<T>) {
  const rendered = useMemo(() => value === selectedTab, [selectedTab, value]);

  if (!rendered) {
    return null;
  }

  return (
    <Box
      id={`dd-tabpanel-${stringifyValue(value)}`}
      {...other}
      sx={[{ display: value === selectedTab ? "flex" : "none", width: "100%" }, ...(Array.isArray(sx) ? sx : [sx])]}
    >
      {children}
    </Box>
  );
}
